var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "733B7E94-D8D3-4F56-AB0A-B8C1362FCB40") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.191,0 C0.127,0 0.064,0.009 1.50990331e-14,0.01 L1.50990331e-14,7.01 C0.064,7.008 0.127,7 0.191,7 C4.609,7 8.191,10.582 8.191,15 L15.191,15 C15.191,6.716 8.475,0 0.191,0",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.739,16.816 C21.851,20.268 18.728,22.822 15,22.822 C10.581,22.822 7,19.24 7,14.822 C7,11.165 9.457,8.087 12.808,7.133 L12.808,1.77635684e-15 C5.565,1.063 -1.24344979e-14,7.284 -1.24344979e-14,14.822 C-1.24344979e-14,23.106 6.716,29.822 15,29.822 C22.606,29.822 28.875,24.155 29.852,16.816 L22.739,16.816 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-203.000000, -336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WPB-Widgets",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components",
    transform: "translate(160.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Pie-Chart/40dp",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(19.808700, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.808700, -5.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Dark",
    mask: "url(#mask-4)",
    fill: "#727272"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.000000, -5.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pieChart.98c303add3dd7c5821e2058b73d998f8.svg";
export { ForwardRef as ReactComponent };